<template>
    <cic-popup
        :title="item.templateId ? 'Edit Email Template' : 'New Email Template'"
        :editable="
            item.templateId > 0 && item.orgId === $store.user.orgId && $store.hasRight('EDIT_TRANSMIT_TEMPLATES')
        "
        :saveable="
            item.templateId <= 0 || (item.orgId === $store.user.orgId && $store.hasRight('EDIT_TRANSMIT_TEMPLATES'))
        "
        @blur="$emit('blur')"
        @edit="toggleEdit"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('Name') }}
                </li>
                <li>
                    <cic-textbox
                        id="template_name"
                        :value="item.name"
                        :enabled="editing"
                        :maxlength="50"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Share To Child Organisations') }}
                </li>
                <li>
                    <cic-checkbox
                        id="template_share"
                        :value="item.share"
                        :enabled="editing"
                        @input="(val) => updateFieldValue('share', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Subject') }}
                </li>
                <li>
                    <cic-textbox
                        id="template_subject"
                        :value="item.subject"
                        :enabled="editing"
                        :maxlength="512"
                        @input="(val) => updateFieldValue('subject', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Message') }}
                </li>
                <li>
                    <cic-textarea
                        id="template_message"
                        :value="item.message"
                        :enabled="editing"
                        :autosize="true"
                        @input="(val) => updateFieldValue('message', val)"
                    />
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicTextarea from '@/components/inputs/CicTextarea';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditTransmitTemplate',
        components: {
            CicCheckbox,
            CicPopup,
            CicTextarea,
            CicTextbox,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'input', 'updateFieldValue'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = this.item.templateId <= 0;
        },
        methods: {
            toggleEdit() {
                this.editing = !this.editing;
            },

            updateFieldValue(field, value) {
                this.$emit('updateFieldValue', field, value);
            },
        },
    };
</script>
